angular.module("app").controller("CasinoGamesListPageController", [
    '$scope',
    'pagination',
    '$timeout',
    'casinoGameService',
    'errorHandler',
    '$state',
    'preloadedData',
    'preloadedCategories',
    'logger',
    'preloadedProviders',
    'settingsService',
    'userStorage',
    '$rootScope',
    '$uibModal',
    'casinoJackpot',
    'unapprovedGamesCount',
    function ($scope, pagination, $timeout, casinoGameService, errorHandler, $state, preloadedData, preloadedCategories, logger, preloadedProviders, settingsService, userStorage, $rootScope, $modal, casinoJackpot, unapprovedGamesCount) {
        var pendingListRequest,
            initialDataForGames = angular.copy(preloadedData.skinGames);

        $scope.disableSaveOrdersBtn = true;
        $scope.games = angular.copy(preloadedData.skinGames);
        $scope.jackpot = angular.copy(casinoJackpot);
        $scope.unapprovedGamesCount =  unapprovedGamesCount;
        var hasPermission = userStorage.getUserData().permissions.indexOf('manageSkinGames') !== -1;
        $scope.labelColumnContainer = {
            column: "name",
            field: "label"
        };
        $scope.jackpot.unshift({
            key: "All",
            value: ""
        });

        $scope.tabOptions = {};
        $scope.filterOptions = {
            status: 'active',
            search: '',
            jackpot: $scope.jackpot[0].value,
            gameType: 'all',
            showUnapproved: false
        };
        $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());
        if (angular.isDefined($scope.filterOptions.is_mobile)) {
            $scope.filterOptions.gameType = $scope.filterOptions.is_mobile == 1 ? 'mobile' : 'desktop';
        } else {
            $scope.filterOptions.gameType = 'all'
        }
        var oldStatus;



        $scope.multiSelect = {};
        $scope.multiSelect.categories = preloadedCategories;
        $scope.multiSelect.selectedCategories =  [];
        $scope.multiSelect.providers = preloadedProviders;
        $scope.multiSelect.selectedProviders =  [];

        $scope.getProviderFullName = function (key) {
            for (var i = 0, length = $scope.multiSelect.providers.length; i < length; i++) {
                if ($scope.multiSelect.providers[i].name === key) {
                    return $scope.multiSelect.providers[i].title;
                }
            }
        };

        $scope.games = $scope.games.map(extractGame);
        function extractGame(game) {
            game.categories =  game.categories.reduce(function (prev, curr) {
                if (prev === "") {
                    return prev + curr.title;
                } else {
                    return prev + ", " + curr.title;
                }
            }, "");
            if (game.categories === ""){
                game.categories = "Not selected";
            }
            var image = undefined;
            if (game.game.background && !game.game.icon_1 && !game.game.icon_2) {
                image = game.game.background;
            }
            if (!!game.game.icon_1) {
                image = game.game.icon_1;
            }
            if (!game.game.icon_1 && (!!game.game.icon_2 || !!game.game.icon_3)) {
                image = game.game.icon_2;
            }
            if (!!game.game.icon_3 && !game.game.background && !game.game.icon_1 && !game.game.icon_2){
                image = game.game.icon_3;
            }
            return {
                name: game.game.name,
                images: image,
                order: game.order > 0 ? game.order : 'AI',
                is_mobile: game.game.is_mobile == 1? 'Mobile': "Web",
                categories: game.categories,
                provider: game.game.provider_title || 'Not selected',
                created_at: game["created_at"],
                active: game.active,
                id: game.game.id,
                gameSkinId: game.gameSkinId,
                label: game.badge
            }
        }

        var getPage = function(resetPage) {
            var requestData = getFiltersValues();
            requestData.current_page =  $scope.pagination.page;
            requestData.limit = $scope.pagination.limit;
            resetPage && (requestData.current_page = 1);
            updateList(requestData);
        };

        $scope.pagination = pagination.init(function (resetPage) {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                getPage(resetPage === true);
            }, 300);
        }, preloadedData.total_count, 25);

        $scope.editGame = function (game) {
            $modal.open({
                templateUrl: "views/casinoGames/edit.html",
                controller: "CasinoGamesEditPageController",
                resolve: {
                    currencies: function(resourcesService) {
                        return resourcesService.getResource("currencies.json").then(function (data) {
                            return angular.copy(data);
                        },function (response) {
                            return [];
                        });
                    },
                    preloadedGameData: function (casinoGameService, errorHandler) {
                        return casinoGameService.getSkinGames({gameSkinId: game.gameSkinId}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy({
                                        id: response.skinGame.gameSkinId,
                                        active: response.skinGame.active,
                                        name: response.skinGame.name,
                                        description: response.skinGame.description,
                                        categories: response.skinGame.categories,
                                        background: response.skinGame.backgrounds,
                                        icon: response.skinGame.icons,
                                        badge: response.skinGame.badge,
                                        show_on_page: response.skinGame.show_on_page,
                                        licenseIcons: response.skinGame.licenseIcons,
                                        bet_limits: response.skinGame.bet_limits,
                                        cert_number: response.skinGame.cert_number,
                                    })
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedCategories: function (casinoCategoryService, pageStatuses, errorHandler) {
                        return casinoCategoryService.get({status: pageStatuses[0], type: "category", skin_id: "me"}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response.categories)
                                } else {
                                    errorHandler(response.message);
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    }

                }
            }).result.then(function () {
                getPage();
            })
        };

        $scope.onFilterSelect
            = $scope.onFilterDeselect
            = $scope.onFilterSelectAll
            = $scope.onFilterDeselectAll
            = function () {
            return $scope.pagination.changePage()
        };

        $scope.toggleGameActivity = function (gameData, action) {
            var requestData = {
                skinGame: {
                    id: gameData.gameSkinId,
                    active: action
                }
            };
            casinoGameService.editSkinGame(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        if ($scope.filterOptions.showUnapproved) {
                            casinoGameService.getUnapprovedGamesCount({}).then(function (res) {
                                $scope.unapprovedGamesCount = res.count;

                                if ($scope.unapprovedGamesCount === 0) {
                                    $scope.filterOptions.showUnapproved = false;
                                    $scope.changeUnplayedAmount();
                                }

                                $scope.filterOptions.status !== 'all' && spliceFromList(gameData);
                                logger.logSuccess(action ? "global.activated" : "global.disabled");

                            })
                        } else {
                            $scope.filterOptions.status !== 'all' && spliceFromList(gameData);
                            logger.logSuccess(action ? "global.activated" : "global.disabled");
                        }
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        function spliceFromList(game) {
            var index = $scope.games.indexOf(game);
            if (index != -1) {
                $scope.games.splice(index, 1);
            }
        }

        function updateList(requestOptions) {
            settingsService.setFilters(requestOptions);
            casinoGameService.getSkinGames(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.games = angular.copy(response.skinGames);
                        $scope.games = $scope.games.map(extractGame);
                        $scope.discardChanges();
                        initialDataForGames = angular.copy(response.skinGames);
                        $scope.pagination.totalItems = response.total_count;
                        $scope.pagination.page = requestOptions.current_page ? requestOptions.current_page : $scope.pagination.page;
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }
        if (hasPermission) {
            $scope.allowUpdateContainer = {
                allowUpdate: function (options) {
                    if (options && options.autoUpdate) {
                        reorder();
                    } else if (!!options) {
                        $scope.tabOptions.reordered = true
                    }
                }
            };
        }


        function saveOrdering(requestData) {
            casinoGameService.changeOrderSkinGames(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.updated");
                        if(!requestData.drop) {
                            getPage();
                        }
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        function reorder () {
            if (typeof $scope.games === "object" && $scope.games.length) {
                var list = [],
                    orders = [];

                $scope.games.forEach(function (item) {
                    if (item.order === 'AI') {
                        return;
                    }

                    list.push(item.gameSkinId);
                });

                initialDataForGames.forEach(function (item, index) {
                    if (item.order < 1) {
                        return;
                    }

                    $scope.games[index].order = item.order;
                    if ($scope.games[index].model) {
                        $scope.games[index].model.order = item.order;
                    }
                    initialDataForGames[index].order = item.order;
                    orders.push(item.order);
                });
                writtenOrders = {};

                saveOrdering({ids: list, orders: orders, drop: true});
            }
        }

        function getFiltersValues() {
            var filtersData = {},
                isActive = (($scope.filterOptions.status === 'active') || (($scope.filterOptions.status === 'all') ? undefined : false));


            filtersData.current_page = $scope.pagination.page;
            filtersData.limit = $scope.pagination.limit;
            filtersData.categories = $scope.multiSelect.selectedCategories;
            filtersData.providers = $scope.multiSelect.selectedProviders;
            filtersData.search = $scope.filterOptions.search;
            filtersData.is_mobile = ($scope.filterOptions.gameType == 'mobile' ? 1 : ($scope.filterOptions.gameType == 'desktop' ? 0 : undefined));

            if ($scope.filterOptions.showUnapproved) {
                filtersData.not_approved = 1;
            }

            if (hasPermission) {
                filtersData.jackpot = $scope.filterOptions.jackpot != $scope.jackpot[0].value ? $scope.filterOptions.jackpot : undefined;
                !filtersData.jackpot && (delete filtersData.jackpot);
            }


            (filtersData.is_mobile === undefined) && (delete filtersData.is_mobile);
            !filtersData.search && (delete filtersData.search);

            angular.isDefined(isActive) && (filtersData.active = isActive);
            return filtersData
        }

        $scope.saveOrdering = function () {
            var gamesLength = $scope.games.length;
            var requestOrders = {};
            var i = 0;
            for(var j = 0; j < gamesLength; ++j){
                var row = $scope.games[j];

                if (row.model.order === 'AI') {
                    continue;
                }

                if (!isNaturalNumber(row.model.order)) {
                    logger.logError("global.orderMustBeNaturalNumber");
                    return;
                }
                if(row.model.order !== row.order) {
                    requestOrders[i] = {
                        id: row.gameSkinId,
                        initialOrder: row.order,
                        newOrder: row.model.order
                    };
                    ++i;
                }

            }
            if (_.isEmpty(requestOrders)) {
                logger.logError("global.no_changes");
                return;
            }
            saveOrdering({orders:requestOrders});
        };


        $scope.listFilterObject = {
            action: function () {
                getPage(true);
            }
        };

        $scope.ignoreColumns = {
            gameSkinId: true,
            id: true,
            active: true,
            "$$hashKey": true,
            model: true,
            label: true
        };
        if (hasPermission) {
            $scope.tools = {
                switch: {
                    name: function (item) {
                        return 'active';
                    },
                    model: function () {
                        return "active";
                    },
                    "class":function (){
                        return $scope.filterOptions.showUnapproved?"orange-passive":"";
                    },
                    change: function (item) {
                        item.active ? $scope.toggleGameActivity(item, true) :  $scope.toggleGameActivity(item, false)
                    }
                },
                edit: {
                    action: function (item) {
                        $scope.editGame(item);
                    },
                    class: function (){
                        return "";
                    }
                }
            };
        }


        $scope.tableIsInEditMode = false;
        /**
         * Table edit orders function
         */
        $scope.editTable = function () {
            if ($scope.tableIsInEditMode){
                return;
            }
            $scope.tableIsInEditMode = true;
            var tables = {
                "name": {type: 'empty'},
                "images": {type: 'empty'},
                "order": {type: "order"},
                "is_mobile": {type: 'empty'},
                "categories": {type: 'empty'},
                "provider": {type: 'empty'},
                "created_at": {type: 'empty'}
            };
            var gamesLength = $scope.games.length;
            for(var i = 0; i < gamesLength; ++i){
                var row = $scope.games[i];
                row.model = {};
                for(var key in row){
                    if (row.hasOwnProperty(key) && tables[key] !== undefined && tables[key].type !== 'empty') {
                        $scope.games[i].model[key] =  row[key];
                    }
                }
            }
            $scope.updateRow = tables;
            $rootScope.broadcast('changeToEditMode', true);
        };
        /**
         * Discard table changes
         */
        $scope.discardChanges = function discardChanges() {
            if ($scope.tableIsInEditMode) {
                writtenOrders = {};
                $scope.tableIsInEditMode = false;
                $rootScope.broadcast('changeToEditMode', false);
            }
        };

        /**
         * Check is given string contains natural number
         * @param n string containing number
         * @returns {boolean}
         */
        function isNaturalNumber(n) {
            n = n.toString(); // force the value incase it is not
            var n1 = Math.abs(n),
                n2 = parseInt(n, 10);
            return !isNaN(n1) && n2 === n1 && n1.toString() === n;
        }

        /**
         * Check is order changed
         */
        $scope.checkForChanges = function checkForChanges() {
            if($scope.tableIsInEditMode) {
                var gamesLength = $scope.games.length;
                for(var j = 0; j < gamesLength; ++j) {
                    var row = $scope.games[j];
                    if(row.model.order !== row.order) {
                        return true;
                    }
                }
                return false;
            }
            return true;
        };
        var writtenOrders = {};
        $scope.onBlurContainer =  {
            action: function (row) {
                if (writtenOrders[row.model.order] !== undefined) {
                    row.model.order = row.order;
                } else {
                    writtenOrders[row.model.order] = 1;
                }
            }
        };


        $scope.changeUnplayedAmount = function changeUnplayedAmount() {
            $scope.pagination.page = 1;
            if ($scope.filterOptions.showUnapproved) {
                oldStatus = $scope.filterOptions.status;
                $scope.filterOptions.status = "disabled"
            } else {
                $scope.filterOptions.status= oldStatus || 'all';
            }
            $scope.pagination.changePage(true);
        };


    }
]);
